import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Navigation } from "@/components/Navigation";
import { RoundGroupedMatches } from "@/components/RoundGroupedMatches";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Calendar as CalendarIcon, ArrowLeft } from "lucide-react";
import { useChampionship } from "@/contexts/ChampionshipContext";
import volleyballApi from "@/services/api";

export const CalendarPage = () => {
  const { championshipId } = useParams();
  const navigate = useNavigate();
  const { selectedChampionship } = useChampionship();
  const [allMatches, setAllMatches] = useState([]);
  
  const championship = selectedChampionship || {
    name: "Serie D Maschile Gir. A",
    series: "Serie D",
    gender: "Maschile",
    group: "A"
  };
  
  useEffect(() => {
    const fetchMatches = async () => {
      if (!championshipId) return;
      
      try {
        const matches = await volleyballApi.getChampionshipMatches(championshipId);
        setAllMatches(matches);
      } catch (error) {
        console.error("Error loading matches:", error);
      }
    };
    
    fetchMatches();
  }, [championshipId]);
  
  return (
    <div className="min-h-screen bg-gradient-to-b from-background to-muted/30">
      <Navigation />
      
      <div className="container mx-auto px-4 py-12">
        <Button
          variant="ghost"
          onClick={() => navigate(`/championship/${championshipId}`)}
          className="mb-6"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Indietro
        </Button>
        
        <div className="mb-8 text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 mb-4 rounded-full bg-secondary/10">
            <CalendarIcon className="w-8 h-8 text-secondary" />
          </div>
          <h1 className="text-4xl sm:text-5xl font-bold mb-3">
            Calendario Partite
          </h1>
          <p className="text-lg text-muted-foreground">
            {championship.series} {championship.gender} - Girone {championship.group}
          </p>
        </div>
        
        {/* Grouped View - Always shown */}
        <RoundGroupedMatches matches={allMatches} />
      </div>
      
      <Footer />
    </div>
  );
};

export default CalendarPage;
